export default "/images/ar.png?42958c4bb602afd0925766603e491e71";